<template>
    <div class="gotob" @click="goOff()">返回</div>
</template>

<script>
export default {
  name: 'GoBack',
  data () {
    return {}
  },
  methods:{
    goOff(){
      if (window.history.length <= 1) {
        this.$router.push({path:'/'})
        return false
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gotob{
  width: 49px;
  height: 40px;
  padding-left: 35px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: #0B42AF;
  position: absolute;
  right: 0;
  top:-40px;
  font-size: 16px;
  color: #DBE1F1;
  line-height: 40px;
  cursor: pointer;
  background-image: url("../../assets/goto.fw.png");
  background-repeat: no-repeat;
  background-position: 9px 10px;
  z-index: 99;
}

.gotob:hover{
  text-shadow: 2px 2px 4px rgba(0,0,0,.4);
  background-color: #0B3999;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout-goback.vue